// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "GalleryImageElement" : chunkId) + "." + {"3":"b9074508779940a9","502":"a632ce8d5abf2af5"}[chunkId] + ".js";
};